import type { AxiosError } from 'axios';

type Metadata = {
  status: number;
  url: string;
  method: string | undefined;
  params: Record<string, unknown> | null;
  payload: Record<string, unknown> | null;
};

type VerboseError = {
  error: { code: string; details: string; message: string };
};

type BriefError = {
  message: string;
};

export type AxiosAutoPassErrorConverterReturn = {
  code?: string;
  details?: string;
  message: string;
  metadata: Metadata;
};

export type AutopassError = VerboseError | BriefError;
export type AutopassAxiosError = AxiosError<AutopassError>;

export const axiosAutoPassErrorConverter = (
  error: AutopassAxiosError,
): AxiosAutoPassErrorConverterReturn => {
  const { baseURL, url, method, params, data: payload } = error.config ?? {};

  if (error.response == null)
    return {
      metadata: {
        status: 999,
        url: `${baseURL}${url}`,
        method,
        params: params ?? null,
        payload: payload ? JSON.parse(payload) : null,
      },
      message: '未知錯誤',
    };

  const { data, status } = error.response;

  const metadata: Metadata = {
    status,
    url: `${baseURL}${url}`,
    method,
    params: params ?? null,
    payload: payload ? JSON.parse(payload) : null,
  };

  if (status >= 500) {
    return {
      metadata,
      message: '系統錯誤，請稍後再試',
    };
  }

  if (typeof data === 'string') {
    return {
      metadata,
      message: '未知錯誤',
    };
  }

  if ('error' in data) {
    const { error } = data;

    if (typeof error === 'string') {
      return {
        message: error,
        metadata,
      };
    }

    const {
      error: { code, details, message },
    } = data as VerboseError;

    return {
      code,
      details,
      message,
      metadata,
    };
  }

  if ('message' in data) {
    const { message } = data as BriefError;

    return {
      message,
      metadata,
    };
  }

  return {
    metadata,
    message: '未知錯誤',
  };
};
